import Client from './../Clients/axiosClient'
const resource = '/api/marketplace/orders'

export default {
  get (payload) {
    return Client.get(`${resource}`, { params: payload })
  },
  getCounters () {
    return Client.get(`${resource}/counters`)
  },
  getOrder (id) {
    return Client.get(`${resource}/${id}`)
  },
  create (payload) {
    return Client.post(`${resource}`, payload)
  },
  update (payload, id) {
    return Client.put(`${resource}/${id}`, payload)
  },
  delete (id) {
    return Client.delete(`${resource}/${id}`)
  }
  // MANY OTHER ENDPOINT RELATED STUFFS
}
